<template>
  <BreadCrumb PageTitle="Ajouter une question QCM" />
  <AddQuestionQCM />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddQuestionQCM from "@/components/Question/AddQuestionQCM.vue";

export default defineComponent({
  name: "AddQuestionQCMPage",
  components: {
    BreadCrumb,
    AddQuestionQCM,
  },
});
</script>